import { render, staticRenderFns } from "./BulkShipmentInfo.vue?vue&type=template&id=c3577478&scoped=true&"
import script from "./BulkShipmentInfo.vue?vue&type=script&lang=ts&"
export * from "./BulkShipmentInfo.vue?vue&type=script&lang=ts&"
import style0 from "./BulkShipmentInfo.vue?vue&type=style&index=0&id=c3577478&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3577478",
  null
  
)

export default component.exports